import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_IPO_ALLOT } from "../../../config/api";
import { getIpo } from "./getIpo";
import { getIpoSubscriptions } from "./getIpoSubscriptions";

// data is either { allot_all_in_full: true } or
// { allotments: [{ subscription_id, shares_allotted }] }.
// The response settles per row, so a 200 with failed > 0 is a normal
// outcome — the caller renders results[] rather than treating it as an error.
export const allotIpo = createAsyncThunk(
  "ipos/allot",
  async ({ id, data, callback }, { dispatch, rejectWithValue }) => {
    try {
      const response = await Client({
        method: "POST",
        path: API_IPO_ALLOT(id),
        data,
      });
      const result = response?.data?.data;
      if (result?.failed > 0) {
        toast.warn(
          `${result?.applied ?? 0} allotted, ${result?.failed} failed`
        );
      } else {
        toast.success(response?.data?.message || "Allotment applied");
      }
      dispatch(getIpo(id));
      dispatch(getIpoSubscriptions({ id }));
      callback && callback(result);
      return result;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
